
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-date-time-range-config",
})
export default class DateTimeRangeConfig extends ComponentConfigMixins {}
